import React from "react";
import { useT } from "@/lib/LanguageContext";
import { PERIODS, PERIOD_KEYS } from "../contract";
import CrmSelect from "../ui/CrmSelect";
import CrmInput from "../ui/CrmInput";
import { CRM } from "../../../constants/testIds/crm";

/**
 * "Last 7 days, Last 30 days, Last 90 days, This year, Custom. Default 30 days."
 * Custom reveals a from/to pair; the zone recalculates once both are set.
 *
 * `value`: `{period, from?, to?}` (dates as `YYYY-MM-DD`).
 */
export default function PeriodSelect({ value, onChange }) {
  const t = useT("crm");
  return (
    <div className="flex flex-wrap items-center gap-2">
      <CrmSelect
        aria-label={t("perf.period")}
        value={value.period}
        onChange={(e) => onChange(e.target.value === "custom" ? { period: "custom", from: value.from || "", to: value.to || "" } : { period: e.target.value })}
        options={PERIODS.map((p) => ({ value: p, label: t(PERIOD_KEYS[p]) }))}
        selectClassName="w-auto"
        data-testid={CRM.perfPeriod}
      />
      {value.period === "custom" && (
        <>
          <CrmInput type="date" aria-label={t("perf.from")} value={value.from || ""} max={value.to || undefined}
            onChange={(e) => onChange({ ...value, from: e.target.value })} className="w-auto" data-testid={CRM.perfFrom} />
          <CrmInput type="date" aria-label={t("perf.to")} value={value.to || ""} min={value.from || undefined}
            onChange={(e) => onChange({ ...value, to: e.target.value })} className="w-auto" data-testid={CRM.perfTo} />
        </>
      )}
    </div>
  );
}
